import * as React from 'react';
import {
  Box,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import HTMLContent from './HTMLContent';

const InformationTable = (props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        my: 3,
        width: '100%', minWidth: 0,
      }}
    >
      <TableContainer tabIndex={0} role="region" aria-label={props.label || "Scrollable data table"}
        sx={{ overflowX: 'auto', border: 1, borderColor: 'divider', borderRadius: 1 }}>
        <Table size='small' aria-label={props.label || "Information table"}>
          <TableHead>
            <TableRow>
              {props.headers.map((header, index) => (
                <TableCell scope="col" key={index}>
                  <HTMLContent content={header} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.rows.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                {row.cells.map((cell, cellIndex) => (
                  <TableCell key={cellIndex} align='left'>
                    <HTMLContent content={cell} />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {props.annotation && <Typography variant='body2' sx={{ mt: 1 }}>{props.annotation}</Typography>}
    </Box>
  );
};

export default InformationTable;
